// Google Ads / gtag helpers
export const GADS_ID = "AW-18150272478";

// Paste your Google Ads conversion labels here (the part AFTER "AW-18150272478/").
// Leave "" to skip counting that action as an Ads conversion (the event still fires for GA/tag).
export const CONVERSION_LABELS = {
  book: "hpqSCOz889AcEN7b3M5D",      // Booking form submitted
  call: "mF_oCMX18tAcEN7b3M5D",      // Phone number / Call button clicked
  whatsapp: "aoaCCKCi9NAcEN7b3M5D",  // WhatsApp button clicked
  // NOTE: pageview intentionally NOT a conversion label — page views fire
  // as a normal GA `page_view` event via gtagPageview() so they DO NOT
  // inflate the Google Ads WhatsApp conversion count.
};

// Default value/currency sent per conversion (can be overridden per call)
const CONVERSION_DEFAULTS = {
  book: { value: 1.0, currency: "INR" },
  call: { value: 500.0, currency: "INR" },
  whatsapp: { value: 1.0, currency: "INR" },
};

// Fire a generic gtag event (safe no-op if gtag isn't loaded)
export function gtagEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Fire a Google Ads conversion — only if a label is configured for the key
export function gtagConversion(key, params = {}) {
  const label = CONVERSION_LABELS[key];
  if (label && typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: `${GADS_ID}/${label}`,
      ...(CONVERSION_DEFAULTS[key] || {}),
      ...params,
    });
  }
}

// Fire a plain GA page_view event (NOT an Ads conversion). Use this on route
// changes / SEO landing loads so analytics has page-level visitor data without
// inflating Google Ads conversion counts.
export function gtagPageview(path) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: path || (typeof window !== "undefined" ? window.location.pathname : "/"),
    });
  }
}
